module.exports = __webpack_public_path__ + "img/T6-D-rc_11.79abdca9.png";